import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Button, Form, InputNumber, Spin, Alert } from "antd";
import { toast } from "react-toastify";
import SideBar from "../../../components/SideBar";
import NavBar from "../../../components/NavBar";
import Footer from "../../../components/Footer";
import axiosInstance from "../../../variables/api/axiosInstance";

// Écran dédié au paramétrage de la durée (en jours) avant mise en corbeille automatique
// d'une proposition non traitée. La durée est gérée PAR COMPAGNIE : les endpoints dédiés
// /api/parametre/delai-corbeille résolvent la compagnie depuis l'utilisateur connecté.
const DelaiCorbeille = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [param, setParam] = useState(null); // paramètre existant pour cette compagnie (ou null)
  const [form] = Form.useForm();

  const fetchParam = () => {
    setLoading(true);
    axiosInstance
      .get(`/api/parametre/delai-corbeille`)
      .then((res) => {
        // Renvoie le paramètre de la compagnie de l'utilisateur (ou null/"" si non défini).
        const existing = res.data && res.data.valeur ? res.data : null;
        setParam(existing);
        form.setFieldsValue({
          valeur: existing && existing.valeur ? Number(existing.valeur) : undefined,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchParam();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = (values) => {
    setSaving(true);
    axiosInstance
      .put(`/api/parametre/delai-corbeille/${values.valeur}`)
      .then(() => {
        toast.success("Durée de mise en corbeille enregistrée pour votre compagnie.");
        fetchParam();
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || "Erreur lors de l'enregistrement de la durée";
        toast.error(msg);
        console.error(err);
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu={"AUTRES_PARAMETRES"} />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <Container fluid>
              <Row className="justify-content-md-center">
                <Col md={8}>
                  <Card className="mt-3">
                    <Card.Header style={{ backgroundColor: "#f8f9fa" }}>
                      <h4 className="mb-0">Délai de mise en corbeille des propositions</h4>
                    </Card.Header>
                    <Card.Body>
                      <Alert
                        type="info"
                        showIcon
                        style={{ marginBottom: 16 }}
                        message="Mise en corbeille automatique (propre à votre compagnie)"
                        description="Cette durée s'applique uniquement à votre compagnie : les propositions non traitées au-delà de ce nombre de jours sont automatiquement déplacées dans la corbeille (traitement quotidien). Modifiable à tout moment."
                      />
                      <Spin spinning={loading}>
                        <Form form={form} layout="vertical" onFinish={handleSave}>
                          <Form.Item
                            name="valeur"
                            label="Nombre de jours avant mise en corbeille"
                            rules={[
                              { required: true, message: "Veuillez saisir un nombre de jours" },
                              {
                                type: "number",
                                min: 1,
                                message: "La durée doit être d'au moins 1 jour",
                              },
                            ]}
                          >
                            <InputNumber
                              min={1}
                              step={1}
                              style={{ width: 220 }}
                              placeholder="Ex : 30"
                              addonAfter="jours"
                            />
                          </Form.Item>

                          {param?.valeur ? (
                            <p className="text-muted">
                              Valeur actuelle : <strong>{param.valeur} jours</strong>
                            </p>
                          ) : (
                            <p className="text-muted">
                              Aucune durée définie pour le moment (valeur de repli : 30 jours).
                            </p>
                          )}

                          <Button type="primary" htmlType="submit" loading={saving}>
                            Enregistrer
                          </Button>
                        </Form>
                      </Spin>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default DelaiCorbeille;
